// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/@remotion/bundler/dist/fast-refresh/runtime.js");
__webpack_require__("./node_modules/@remotion/bundler/dist/setup-environment.js");
__webpack_require__("./src/index.ts");
__webpack_require__("./node_modules/@remotion/bundler/react-shim.js");
var __webpack_exports__ = __webpack_require__("./node_modules/@remotion/studio/dist/previewEntry.js");
